import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Quanto tempo leva pra colocar meu cardápio no ar?",
    a: "Em média 5 minutos. Você tira uma foto do seu cardápio impresso (ou anexa um PDF), a IA extrai os pratos, você confere e publica. Pros 10 primeiros restaurantes da semana, a gente faz esse setup pra você, você só aprova.",
  },
  {
    q: "Vocês cobram comissão por pedido?",
    a: "Não, nunca. A gente cobra mensalidade do plano e ponto. Se você fizer 10 pedidos ou 10 mil pedidos no mês, paga o mesmo valor. Toda a receita do pedido cai 100% no seu bolso.",
  },
  {
    q: "E se eu quiser cancelar?",
    a: "Cancela quando quiser, sem multa, sem aviso prévio. Seu cardápio fica disponível até o fim do ciclo pago, e seus dados ficam exportáveis por mais 30 dias.",
  },
  {
    q: "Quanto custa?",
    a: "Os planos começam em R$29,90/mês no Menu. O Pedidos custa R$69,90/mês e o Operação R$149,90/mês. Cancele quando quiser, sem multa.",
  },
];

export function LandingFaq() {
  return (
    <section className="py-16 md:py-24">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mx-auto max-w-2xl text-center"
        >
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">
            Perguntas frequentes
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            O que outros restaurantes perguntaram antes de começar.
          </p>
        </motion.div>

        <div className="mx-auto mt-10 max-w-3xl">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="rounded-xl border bg-background px-5 shadow-sm"
              >
                <AccordionTrigger className="text-left text-base font-semibold">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] leading-relaxed text-muted-foreground">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
